// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"102":"0af80c88","406":"ef20246a","705":"972ab929","764":"49ff8e5f","972":"972ab929"}[chunkId] + ".chunk.css";
};